import { createFileRoute, redirect } from '@tanstack/react-router';

import { isTenantAdmin, useTenantStore } from '@/auth/tenantStore';
import { ErrorComponent } from '@/components/common/ErrorComponent';
import { useSetBreadcrumbs } from '@/components/layout/breadcrumbs';

import { TeamPage } from './-components/TeamPage';

function TeamRoute() {
  useSetBreadcrumbs([{ label: 'Settings' }, { label: 'Team' }]);
  return <TeamPage />;
}

export const Route = createFileRoute('/settings/team')({
  beforeLoad: () => {
    if (!isTenantAdmin(useTenantStore.getState())) {
      throw redirect({ to: '/contacts', search: { page: 0, pageSize: 25 } });
    }
  },
  component: TeamRoute,
  errorComponent: ErrorComponent,
});
